import script from "./AuthForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthForm.vue?vue&type=script&setup=true&lang=ts"

import "./AuthForm.vue?vue&type=style&index=0&id=323df528&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-323df528"]])

export default __exports__